import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

declare var hbspt: any;
@Component({
  selector: 'app-form-enquiry',
  templateUrl: './form-enquiry.component.html',
  styleUrls: ['./form-enquiry.component.scss'],
})
export class FormEnquiryComponent implements OnInit {
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() contacts: any;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.loadHubSpotForm();
  }
  loadHubSpotForm() {
    const currentUrl = this.router.url;
    console.log('Current Router Link:');

    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    if (currentUrl.includes('vacancies')) {
      script.onload = () => {
        this.createHubSpotFormIndividualPropertyVacancies();
      };
    } else {
      script.onload = () => {
        this.createHubSpotFormIndividualProperty();
      };
    }
    document.body.appendChild(script);
  }

  createHubSpotFormIndividualProperty() {
    hbspt.forms.create({
      region: 'eu1',
      portalId: '145096809',
      formId: '9ad2039e-2ecd-4aac-ad20-50e09fe09229',
      target: '#hubspotForm',
    });
  }

  createHubSpotFormIndividualPropertyVacancies() {
    hbspt.forms.create({
      portalId: '145096809',
      formId: '2a41075c-4c08-418f-9b6e-1303df970739',
      region: 'eu1',
      target: '#hubspotForm',
    });
  }
}
